import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, styled } from '@mui/material';
import { PentairHeading } from './pentair-heading';
import { PentairIconInfo } from './pentair-icon';
const WidgetTitleRoot = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    '&:not(:first-of-type)': {
        marginTop: theme.spacing(1),
    },
}));
export const WidgetTitle = ({ title, icon, actions, ...props }) => {
    return (_jsxs(WidgetTitleRoot, { ...props, children: [_jsx(PentairHeading, { icon: icon, spacing: "none", children: title }), actions && _jsx(Divider, { sx: { width: 24 } }), _jsx(Box, { display: 'flex', gap: 0.5, children: actions })] }));
};
WidgetTitle.defaultProps = {
    icon: _jsx(PentairIconInfo, {}),
};
